<script setup>
defineProps({
  layoutName: {
    type: String,
    default: 'dashboard',
  },
})
</script>

<template>
  <section class="client-layout client-layout--dashboard" :data-layout="layoutName">
    <slot />
  </section>
</template>
